/**
 * Highlight.io 환경별 설정
 * Dev/Production 환경에 따른 버그 트래킹 설정 관리
 *
 * 공식 문서 참고: https://www.highlight.io/docs/sdk/client#options
 *
 * 환경별 설정:
 * - local: 비활성화 (manualStart: true)
 * - development: 모든 옵션 활성화 (디버깅 최적화)
 * - production: 최소 옵션 활성화 (성능 및 보안 최적화)
 *
 * 주요 옵션 (공식 문서 기반):
 * - manualStart: 자동 시작 비활성화 여부
 * - disableConsoleRecording: 콘솔 로그 기록 비활성화 여부
 * - networkRecording: 네트워크 요청/응답 기록 설정
 * - urlBlocklist: 기록에서 제외할 URL 목록
 * - privacySetting: 개인정보 보호 수준
 */

const getHighlightConfig = () => {
  const deployEnv = process.env.REACT_APP_DEPLOY_ENV || 'local';

  const baseConfig = {
    projectId: '0dq3pvqe',
    serviceName: 'pocahontas',
    environment: deployEnv,
    tracingOrigins: true,
    privacySetting: 'default'
  };

  switch (deployEnv) {
    case 'development':
      return {
        ...baseConfig,
        // Development: 모든 옵션 활성화 (디버깅 최적화)
        disableConsoleRecording: false,
        reportConsoleErrors: true,
        // Session Replay 임시 활성화
        disableSessionRecording: false,
        networkRecording: {
          enabled: true,
          recordHeadersAndBody: true,
          urlBlocklist: []
        },
        enablePerformanceRecording: true,
        enableCanvasRecording: true,
        privacySetting: 'none'
      };

    case 'production':
      return {
        ...baseConfig,
        // Production: 최소 옵션 활성화 (성능 및 보안 최적화)
        disableConsoleRecording: true,
        reportConsoleErrors: true,
        // Session Replay 비활성화
        disableSessionRecording: true,
        networkRecording: {
          enabled: true,
          recordHeadersAndBody: true,
          urlBlocklist: [
            // URL 제외시 추가 (보안상 이유로)
          ]
        },
        enablePerformanceRecording: true,
        enableCanvasRecording: false,
        privacySetting: 'strict'
      };
    default:
      return {
        ...baseConfig,
        disableConsoleRecording: false,
        reportConsoleErrors: false,
        // Session Replay 비활성화
        disableSessionRecording: true,
        networkRecording: {
          enabled: false,
          recordHeadersAndBody: false,
          urlBlocklist: []
        },
        enablePerformanceRecording: false
      };
  }
};

export default getHighlightConfig;
